import { Form } from "components";

import React from "react";
import GooglePlacesAutocomplete, {
  getLatLng,
  geocodeByAddress,
} from "react-google-places-autocomplete";
export const Search = (props) => {
  return (
    <div>
      <GooglePlacesAutocomplete
        apiKey={`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`}
        selectProps={{
          placeholder: "Buscar un lugar",
          onChange: (e) => {
            props.setLocation(e.label);
            geocodeByAddress(e.label)
              .then((results) => getLatLng(results[0]))
              .then(({ lat, lng }) => {
                props.changeLocation(Number(lat), Number(lng));
              });
          },
        }}
      />
    </div>
  );
};
